import React from 'react';
import PropTypes from 'prop-types';

/* IMPORTING SELECTED ADDRESS STYLES */
import '../../assets/components/SelectedAddress.scss'; 


export const SelectedAddress = ({ selectedAddress, resetSelectedAddress }) => {
    return (
        <div className="selected-address-item postcode-input">
            <p data-testid="selection-address-details"> { selectedAddress } </p>
            { resetSelectedAddress &&
                <div className="selected-address-alignment">
                    <button type="button" className="btn btn-outline-danger btn-xs" onClick={()=>resetSelectedAddress()}>Change</button>
                </div>
            }
        </div>
    );
};

SelectedAddress.propTypes = {
    /* 
      selected address for component
    */ 
      selectedAddress: PropTypes.string.isRequired,
}
  
SelectedAddress.defaultProps = {
    /*
        default value if selected address is not given
    */
    message: '',
}